<template>
  <div class="content">
    <div v-html="content"></div>
    <Loading v-if="loading"></Loading>
  </div>
</template>

<script>
import "./rem";
import service from "../../utils/request";
import Loading from "@/components/loading/loading";
export default {
  components:{
    Loading
  },
  data() {
    return {
      content: "",
      loading:true
    };
  },
  created() {},

  async mounted() {
    this.loading=true
    const { data } = await service({
      url: "/appSettings/protocol/app/type",
      method: "get",
      params: {
        protocolType: "4",
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
    this.content = data;
    this.loading = false
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 10px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.9);
  padding-top: 10px;
  background: #fff;
  min-height: calc(100vh - 10px);
}
</style>
